import { render } from "./Approve75Liquidations.vue?vue&type=template&id=55f7ea80"
import script from "./Approve75Liquidations.vue?vue&type=script&lang=js"
export * from "./Approve75Liquidations.vue?vue&type=script&lang=js"

import "./Approve75Liquidations.vue?vue&type=style&index=0&id=55f7ea80&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__